import React, {useState, useEffect} from 'react'
import './Login.css'
import { signInWithEmailAndPassword } from 'firebase/auth';
import { auth, db } from '../firebase';
import { useNavigate } from 'react-router-dom'
import { doc, getDoc } from "firebase/firestore";
import { Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button } from '@mui/material'

function Login() {
    const [open, setOpen] = useState(false);
    useEffect(() => {
        if(sessionStorage.getItem('visited') == 'true') {
            console.log("ok")
        }
        else{
            navigate("/welcome")
        }
    }, []);
    const openDialog = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };
    const navigate = useNavigate()
    const myLogin = async (e) => {
        e.preventDefault()
        const uid = document.getElementById('login__dropdown').value
        const password = document.getElementById('login__input').value

        const docRef = doc(db, "empmaster", String(uid));
        const docSnap = await getDoc(docRef);

        if (docSnap.exists()) {
            // console.log("Document data:", docSnap.data());
            if (password == docSnap.data().pin) {
                localStorage.setItem("empname", String(docSnap.data().name))
                localStorage.setItem("empdesig", String(docSnap.data().desig))
                localStorage.setItem("empid", String(docSnap.data().empid))
                localStorage.setItem("kvk", String(docSnap.data().kvk))
                sessionStorage.setItem("login", "true")
                if (
                    document.getElementById("login__dropdown").value == '32' ||
                    document.getElementById("login__dropdown").value == '33' ||
                    document.getElementById("login__dropdown").value == '34' ||
                    document.getElementById("login__dropdown").value == '35' ||
                    document.getElementById("login__dropdown").value == '36'
                ) {
                    navigate("/ddo")
                }
                else if (
                    document.getElementById("login__dropdown").value == '37' ||
                    document.getElementById("login__dropdown").value == '38' ||
                    document.getElementById("login__dropdown").value == '39' ||
                    document.getElementById("login__dropdown").value == '40' ||
                    document.getElementById("login__dropdown").value == '41'
                ) {
                    navigate("/accountant")
                }
                else if (
                    document.getElementById("login__dropdown").value == '1' ||
                    document.getElementById("login__dropdown").value == '2' ||
                    document.getElementById("login__dropdown").value == '3' ||
                    document.getElementById("login__dropdown").value == '4' ||
                    document.getElementById("login__dropdown").value == '5' ||
                    document.getElementById("login__dropdown").value == '6' ||
                    document.getElementById("login__dropdown").value == '7' ||
                    document.getElementById("login__dropdown").value == '8' ||
                    document.getElementById("login__dropdown").value == '9' ||
                    document.getElementById("login__dropdown").value == '10' ||
                    document.getElementById("login__dropdown").value == '11' ||
                    document.getElementById("login__dropdown").value == '12' ||
                    document.getElementById("login__dropdown").value == '13' ||
                    document.getElementById("login__dropdown").value == '14' ||
                    document.getElementById("login__dropdown").value == '15' ||
                    document.getElementById("login__dropdown").value == '16' ||
                    document.getElementById("login__dropdown").value == '17' ||
                    document.getElementById("login__dropdown").value == '18' ||
                    document.getElementById("login__dropdown").value == '19' ||
                    document.getElementById("login__dropdown").value == '20' ||
                    document.getElementById("login__dropdown").value == '21' ||
                    document.getElementById("login__dropdown").value == '22' ||
                    document.getElementById("login__dropdown").value == '23' ||
                    document.getElementById("login__dropdown").value == '24' ||
                    document.getElementById("login__dropdown").value == '25' ||
                    document.getElementById("login__dropdown").value == '26' ||
                    document.getElementById("login__dropdown").value == '27' ||
                    document.getElementById("login__dropdown").value == '28' ||
                    document.getElementById("login__dropdown").value == '29' ||
                    document.getElementById("login__dropdown").value == '30'
                ) {
                    navigate("/user")
                }
                else if (
                    document.getElementById("login__dropdown").value == '42' ||
                    document.getElementById("login__dropdown").value == '43' ||
                    document.getElementById("login__dropdown").value == '44' ||
                    document.getElementById("login__dropdown").value == '45' ||
                    document.getElementById("login__dropdown").value == '46' ||
                    document.getElementById("login__dropdown").value == '47' ||
                    document.getElementById("login__dropdown").value == '48' ||
                    document.getElementById("login__dropdown").value == '49' ||
                    document.getElementById("login__dropdown").value == '50' ||
                    document.getElementById("login__dropdown").value == '51' ||
                    document.getElementById("login__dropdown").value == '52' ||
                    document.getElementById("login__dropdown").value == '53' ||
                    document.getElementById("login__dropdown").value == '54' ||
                    document.getElementById("login__dropdown").value == '55' ||
                    document.getElementById("login__dropdown").value == '56' ||
                    document.getElementById("login__dropdown").value == '57' ||
                    document.getElementById("login__dropdown").value == '58' ||
                    document.getElementById("login__dropdown").value == '59' ||
                    document.getElementById("login__dropdown").value == '60' ||
                    document.getElementById("login__dropdown").value == '61' ||
                    document.getElementById("login__dropdown").value == '62' ||
                    document.getElementById("login__dropdown").value == '63' ||
                    document.getElementById("login__dropdown").value == '64' ||
                    document.getElementById("login__dropdown").value == '65' ||
                    document.getElementById("login__dropdown").value == '66' ||
                    document.getElementById("login__dropdown").value == '67' ||
                    document.getElementById("login__dropdown").value == '68' ||
                    document.getElementById("login__dropdown").value == '69' ||
                    document.getElementById("login__dropdown").value == '70' ||
                    document.getElementById("login__dropdown").value == '71' ||
                    document.getElementById("login__dropdown").value == '72' ||
                    document.getElementById("login__dropdown").value == '73' ||
                    document.getElementById("login__dropdown").value == '74' ||
                    document.getElementById("login__dropdown").value == '75' ||
                    document.getElementById("login__dropdown").value == '76' ||
                    document.getElementById("login__dropdown").value == '77' ||
                    document.getElementById("login__dropdown").value == '78' ||
                    document.getElementById("login__dropdown").value == '79' ||
                    document.getElementById("login__dropdown").value == '80' ||
                    document.getElementById("login__dropdown").value == '81'

                ) {
                    navigate("/otherstaff")
                }
                else if (document.getElementById("login__dropdown").value == '31') {
                    navigate("/dee")
                }
                else if (
                    document.getElementById("login__dropdown").value == '82' ||
                    document.getElementById("login__dropdown").value == '83' ||
                    document.getElementById("login__dropdown").value == '84' ||
                    document.getElementById("login__dropdown").value == '85' ||
                    document.getElementById("login__dropdown").value == '86') {
                    navigate("/ssh")
                }

            }
            else {
                localStorage.setItem("login", "false")
                alert("Wrong PIN! Try again")
            }
        } else {
            console.log("No such document");
        }
    }

    return (
        <div className='login__container'>
            <Dialog
                open={open}
                onClose={handleClose}
                aria-labelledby="forgot-pin-dialog-title"
                aria-describedby="forgot-pin-dialog-description"
            >
                <DialogTitle id="forgot-pin-dialog-title">Reset Password</DialogTitle>
                <DialogContent>
                    <DialogContentText id="forgot-pin-dialog-description">
                        To Reset your PIN, send a WhatsApp Message to 7001841402
                        <br />
                        <p style={{ color: 'brown'}}>Reset PIN &lt;KVK Name&gt; &lt;Designation&gt; &lt;New PIN&gt;</p>
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose} color="primary">
                        Close
                    </Button>
                </DialogActions>
            </Dialog>
            <center><h1 className='login__headerText'>Welcome to<br /> KVK Financial Management System</h1></center>
            <div className='login__screen'>
                <div className='login__screen__content'>
                    <form className='login'>
                        <div className=''>
                            <select id='login__dropdown'>
                                <option value='0'>Login as :</option>

                                <option value='31'>DEE</option>
                                <optgroup label="Kalimpong">
                                    <option value='82'>Kalimpong SS & Head</option>
                                    <option value='32'>Kalimpong DDO</option>
                                    <option value='1'>Kalimpong Horticulter</option>
                                    <option value='2'>Kalimpong Soil Science</option>
                                    <option value='3'>Kalimpong Plant Protection</option>
                                    <option value='4'>Kalimpong Animal Science</option>
                                    <option value='5'>Kalimpong Home Science</option>
                                    <option value='6'>Kalimpong Extension</option>
                                    <option value='37'>Kalimpong Accountant</option>
                                    <option value='42'>Kalimpong Farm Manager</option>
                                    <option value='47'>Kalimpong Computer Programmer</option>
                                    <option value='52'>Kalimpong Programme Assistant</option>
                                    <option value='57'>Kalimpong Stenographer</option>
                                    <option value='62'>Kalimpong Driver1</option>
                                    <option value='63'>Kalimpong Driver2</option>
                                    <option value='72'>Kalimpong Skilled Supporting Staff1</option>
                                    <option value='73'>Kalimpong Skilled Supporting Staff2</option>
                                </optgroup>
                                <optgroup label="Coochbehar">
                                    <option value='83'>Coochbehar SS & Head</option>
                                    <option value='33'>Coochbehar DDO</option>
                                    <option value='7'>Coochbehar Horticulture</option>
                                    <option value='8'>Coochbehar Soil Science</option>
                                    <option value='9'>Coochbehar Plant Protection</option>
                                    <option value='10'>Coochbehar Agronomy</option>
                                    <option value='11'>Coochbehar Animal Science</option>
                                    <option value='12'>Coochbehar Extension</option>
                                    <option value='38'>Coochbehar Accountant</option>
                                    <option value='43'>Coochbehar Farm Manager</option>
                                    <option value='48'>Coochbehar Computer Programmer</option>
                                    <option value='53'>Coochbehar Programme Assistant</option>
                                    <option value='58'>Coochbehar Stenographer</option>
                                    <option value='64'>Coochbehar Driver1</option>
                                    <option value='65'>Coochbehar Driver2</option>
                                    <option value='74'>Coochbehar Skilled Supporting Staff1</option>
                                    <option value='75'>Coochbehar Skilled Supporting Staff2</option>
                                </optgroup>
                                <optgroup label="Uttar Dinajput">
                                    <option value='84'>Uttar Dinajpur SS & Head</option>
                                    <option value='34'>Uttar Dinajpur DDO</option>
                                    <option value='13'>Uttar Dinajpur Horticulture</option>
                                    <option value='14'>Uttar Dinajpur Agronomy</option>
                                    <option value='15'>Uttar Dinajpur Plant Protection</option>
                                    <option value='16'>Uttar Dinajpur Animal Science</option>
                                    <option value='17'>Uttar Dinajpur Home Science</option>
                                    <option value='18'>Uttar Dinajpur Fishery Science</option>
                                    <option value='39'>Uttar Dinajpur Accountant</option>
                                    <option value='44'>Uttar Dinajpur Farm Manager</option>
                                    <option value='49'>Uttar Dinajpur Computer Programmer</option>
                                    <option value='54'>Uttar Dinajpur Programme Assistant</option>
                                    <option value='59'>Uttar Dinajpur Stenographer</option>
                                    <option value='66'>Uttar Dinajpur Driver1</option>
                                    <option value='67'>Uttar Dinajpur Driver2</option>
                                    <option value='76'>Uttar Dinajpur Skilled Supporting Staff1</option>
                                    <option value='77'>Uttar Dinajpur Skilled Supporting Staff2</option>
                                </optgroup>
                                <optgroup label="Dakshin Dinajpur">
                                    <option value='85'>Dakshin Dinajpur SS & Head</option>
                                    <option value='35'>Dakshin Dinajpur DDO</option>
                                    <option value='19'>Dakshin Dinajpur Horticulture</option>
                                    <option value='20'>Dakshin Dinajpur Soil Science</option>
                                    <option value='21'>Dakshin Dinajpur Agronomy</option>
                                    <option value='22'>Dakshin Dinajpur Animal Science</option>
                                    <option value='23'>Dakshin Dinajpur Plant Protection</option>
                                    <option value='24'>Dakshin Dinajpur Fishery Science</option>
                                    <option value='40'>Dakshin Dinajpur Accountant</option>
                                    <option value='45'>Dakshin Dinajpur Farm Manager</option>
                                    <option value='50'>Dakshin Dinajpur Computer Programmer</option>
                                    <option value='55'>Dakshin Dinajpur Programme Assistant</option>
                                    <option value='60'>Dakshin Dinajpur Stenographer</option>
                                    <option value='68'>Dakshin Dinajpur Driver1</option>
                                    <option value='69'>Dakshin Dinajpur Driver2</option>
                                    <option value='78'>Dakshin Dinajpur Skilled Supporting Staff1</option>
                                    <option value='79'>Dakshin Dinajpur Skilled Supporting Staff2</option>
                                </optgroup>
                                <optgroup label="Malda">
                                    <option value='86'>Malda SS & Head</option>
                                    <option value='36'>Malda DDO</option>
                                    <option value='25'>Malda Horticulture</option>
                                    <option value='26'>Malda Agronomy</option>
                                    <option value='27'>Malda Plant Protection</option>
                                    <option value='28'>Malda Animal Science</option>
                                    <option value='29'>Malda Extension</option>
                                    <option value='30'>Malda Fishery Science</option>
                                    <option value='41'>Malda Accountant</option>
                                    <option value='46'>Malda Farm Manager</option>
                                    <option value='51'>Malda Computer Programmer</option>
                                    <option value='56'>Malda Programme Assistant</option>
                                    <option value='61'>Malda Stenographer</option>
                                    <option value='70'>Malda Driver1</option>
                                    <option value='71'>Malda Driver2</option>
                                    <option value='80'>Malda Skilled Supporting Staff1</option>
                                    <option value='81'>Malda Skilled Supporting Staff2</option>
                                </optgroup>
                            </select>
                        </div>
                        <div className='login__field'>
                            <i className='login__icon fas fa-lock'></i>
                            <input type='password' className='login__input' placeholder='6-digit PIN' id='login__input' autoComplete='off' />
                        </div>
                        <button className='login__submit' onClick={myLogin} type='submit'>
                            <span className='login__button__text'>Log In Now</span>
                            <i className='login__button__icon fas fa-chevron-right'></i>
                        </button>
                        <br /><br />
                        <b><p style={{ marginLeft: '60%', cursor: '-webkit-grab' }} onClick={openDialog}>Forgot PIN</p></b>
                    </form>
                </div>
                <div className='login__screen__background'>
                    <span className='login__screen__background__shape login__screen__background__shape4'></span>
                    <span className='login__screen__background__shape login__screen__background__shape3'></span>
                    <span className='login__screen__background__shape login__screen__background__shape2'></span>
                    <span className='login__screen__background__shape login__screen__background__shape1'></span>
                </div>
            </div>
        </div>
    )
}

export default Login